import { encryptObject } from "@/helpers/noncehelper";
import { addPoductsToFavouriteList, fetchFavouriteList, removeProductsFromFavouriteList } from "@/services/products";
import { fetchSafeJson } from "@/utils/apiResponse";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchFavouriteProducts = createAsyncThunk(
  "get_favouritelist",
  async (payload: {userToken: string, storeId: string}, {rejectWithValue} ) => {
    const { userToken , ...rest } = payload;
    const data = await fetchFavouriteList(
      encryptObject(payload),
    );

    let safeJson = await fetchSafeJson(data)

    if(safeJson?.status != 400){
      const updatedData = await  safeJson.response?.data?.data?.map((category: { item_id: any; }) => ({
        ...category,
        item_id: `${category?.item_id}_${payload.storeId}`,
    }));
    safeJson.response.data = updatedData
    if(updatedData){
      return safeJson.response;
    }
    }else {
      return rejectWithValue(
        safeJson.response?.details?.details
      );
    }
    
  }
);


// export const addItemToFavouriteList = createAsyncThunk(
//   "add_shopping_list_favourrite",
//   async (payload: {
//     item_id: any;
//     is_favourite: number;
//     userToken: string;
//     storeId: string;
//   }, {rejectWithValue}) => {
//     const {userToken , ...rest} = payload;
//     const data = await addPoductsToFavouriteList(
//       encryptObject(payload),

//     );
//     console.log(data, payload , "safeJson===============")

//     const safeJson = await fetchSafeJson(data);
//     if(safeJson.response?.status != 400){
//       if (safeJson.response) {
//         safeJson.response.itemData = {
//           item_id: `${payload.item_id}_${payload.storeId}`,
//           banner: process.env.NEXT_PUBLIC_BANNER
//         };
//       }
//       return safeJson.response;
//     }else {
//       return rejectWithValue(
//         safeJson.response?.details?.details ? safeJson.response?.details?.details : safeJson.response?.details

//       );
//     }
//   }
// );

export const addItemToFavouriteList = createAsyncThunk(
  "add_item_to_favourite",
  async (payload: {
    item_ids: any;
    userToken: string;
    storeId: string;
  }, {rejectWithValue}) => {
    const {userToken , ...rest} = payload;
    const data = await addPoductsToFavouriteList(
      encryptObject(payload),
    );

    const safeJson = await fetchSafeJson(data.data)
    if (data?.status !== 400) {
      if (!safeJson.response) {
        safeJson.response = {};
      }
    
      safeJson.response.itemData = {
        item_id: `${payload.item_ids[0]}_${payload.storeId}`,
        banner: process.env.NEXT_PUBLIC_BANNER
      };
      return safeJson.response;
    } else {
      return rejectWithValue(
        safeJson?.response?.details?.details ?? safeJson?.response?.details
      );
    }
  }
);

export const removeItemFromFavourite = createAsyncThunk(
  "remove_item_from_favourite",
  async (payload: {
    item_ids: any;
    userToken: string;
    storeId: string;
  }, {rejectWithValue}) => {
    const {userToken , ...rest} = payload;
    const data = await removeProductsFromFavouriteList(
      encryptObject(payload),
    );
    const safeJson = await fetchSafeJson(data.data)
    
    if (data?.status !== 400) {
      if (!safeJson.response) {
        safeJson.response = {};
      }
    
      safeJson.response.itemData = {
        item_id: `${payload.item_ids[0]}_${payload.storeId}`,
        banner: process.env.NEXT_PUBLIC_BANNER
      };
      return safeJson.response;
    }else {
      return rejectWithValue(
        safeJson.response?.details?.details ? safeJson.response?.details?.details : safeJson.response?.details

      );
    }
  }
);